import api from "../../../api/axios";

export const fetchCompanyTasks = (companyId, params) =>
  api
    .get(`/companies/${companyId}/tasks/`, { params })
    .then((res) => res.data);

export const fetchCompanyTask = (companyId, taskId) =>
  api
    .get(`/companies/${companyId}/tasks/${taskId}/`)
    .then((res) => res.data);

export const preflightCompanyTask = (companyId, body) =>
  api
    .post(`/companies/${companyId}/tasks/preflight/`, body)
    .then((res) => res.data);

export const createCompanyTask = (companyId, body) =>
  api
    .post(`/companies/${companyId}/tasks/`, body)
    .then((res) => res.data);

export const patchCompanyTask = (companyId, taskId, body) =>
  api
    .patch(`/companies/${companyId}/tasks/${taskId}/`, body)
    .then((res) => res.data);

export const deleteCompanyTask = (companyId, taskId, params) =>
  api
    .delete(`/companies/${companyId}/tasks/${taskId}/`, { params })
    .then((res) => res.data);

export const assignCompanyTask = (companyId, taskId, body) =>
  api
    .post(`/companies/${companyId}/tasks/${taskId}/assign/`, body)
    .then((res) => res.data);

export const unassignCompanyTask = (companyId, taskId, body) =>
  api
    .post(`/companies/${companyId}/tasks/${taskId}/unassign/`, body)
    .then((res) => res.data);

export const fetchCompanyViewings = (companyId, params) =>
  api
    .get(`/companies/${companyId}/viewings/`, { params })
    .then((res) => res.data);

export const fetchCompanyViewing = (companyId, viewingId) =>
  api
    .get(`/companies/${companyId}/viewings/${viewingId}/`)
    .then((res) => res.data);

export const preflightCompanyViewing = (companyId, body) =>
  api
    .post(`/companies/${companyId}/viewings/preflight/`, body)
    .then((res) => res.data);

export const createCompanyViewing = (companyId, body) =>
  api
    .post(`/companies/${companyId}/viewings/`, body)
    .then((res) => res.data);

export const patchCompanyViewing = (companyId, viewingId, body) =>
  api
    .patch(`/companies/${companyId}/viewings/${viewingId}/`, body)
    .then((res) => res.data);

export const deleteCompanyViewing = (companyId, viewingId, params) =>
  api
    .delete(`/companies/${companyId}/viewings/${viewingId}/`, { params })
    .then((res) => res.data);

export const assignCompanyViewing = (companyId, viewingId, body) =>
  api
    .post(`/companies/${companyId}/viewings/${viewingId}/assign/`, body)
    .then((res) => res.data);

export const unassignCompanyViewing = (companyId, viewingId, body) =>
  api
    .post(`/companies/${companyId}/viewings/${viewingId}/unassign/`, body)
    .then((res) => res.data);
